import { useEffect, useState } from 'react'

import { Input } from '@skytech/ui'
import { Button } from '@skytech/ui/Button'
import { Container } from '@skytech/ui/Container'
import { useDebounce } from '@skytech/utils'
import PlusIcon from 'mdi-react/PlusIcon'
import { useNavigate } from 'react-router-dom'

import { Translation } from '@/app/translations/Translation'
import { useTranslation } from '@/app/translations/translations-hooks'
import Tabs from '@/components/Tabs'
import { useCanManageOnOffboarding } from '@/hooks/access'
import { useSearchParamsByKey } from '@/hooks/searchParams'
import { APP_ROUTES } from '@/util/app-routes'

import { SUB_SERVICE_ORDER_STATUS } from '../constants'

import { statusFilterOptions } from './constants'
import SubscriptionList from './SubscriptionList'

const Subscriptions = () => {
  const navigate = useNavigate()
  const translate = useTranslation()
  const canManageOnOffboarding = useCanManageOnOffboarding()

  const [queryStatus, setQueryStatus] = useSearchParamsByKey('status')
  const [querySearch, setQuerySearch] = useSearchParamsByKey('search')

  const defaultStatusFilter =
    queryStatus === undefined ? SUB_SERVICE_ORDER_STATUS.WAITING_FOR_USER : Number(queryStatus)

  const [searchFilter, setSearchFilter] = useState(querySearch || '')
  const [statusFilter, setStatusFilter] = useState(defaultStatusFilter)

  const debouncedSearchTerm = useDebounce(searchFilter, 500)

  const tabs = statusFilterOptions.map(option => ({
    value: option.value,
    label: <Translation id={`sub_service_order_status/${option.label}`} />,
  }))

  useEffect(() => {
    setSearchFilter(querySearch || '')
    setStatusFilter(defaultStatusFilter)
  }, [defaultStatusFilter, querySearch, queryStatus])

  useEffect(() => {
    setQuerySearch(debouncedSearchTerm)
  }, [debouncedSearchTerm, setQuerySearch])

  return (
    <Container onSwipedLeft={() => navigate(APP_ROUTES.HOME)} className="new-subscription-list">
      <Container.Header>
        <Translation id="New Subscriptions" />
      </Container.Header>

      {canManageOnOffboarding && (
        <Button
          Icon={<PlusIcon />}
          onClick={() => navigate(APP_ROUTES.SUBSCRIPTIONS_NEW_SUBSCRIPTION_LIST_ADD)}
        >
          <Translation id="New Subscription" />
        </Button>
      )}

      <div className="status-filter">
        <div className="status-filter__status">
          <Tabs
            tabs={tabs}
            selectedValue={statusFilter}
            onClick={statusId => {
              setStatusFilter(Number(statusId))
              setQueryStatus(statusId)
            }}
          />
        </div>

        <div className="status-filter__text-filter">
          <Input
            id="subscription-search-filter"
            type="text"
            value={searchFilter}
            placeholder={translate('Search')}
            onChange={e => setSearchFilter(e.target.value)}
          />
        </div>
      </div>

      <SubscriptionList searchFilter={searchFilter} statusFilter={statusFilter} />
    </Container>
  )
}

export default Subscriptions
